import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/capital-gains',
  component: () => import('../../routes/CapitalGains.svelte'),
  card: {
    id: 'capital-gains',
    title: 'Capital Gains Tax',
    description: 'Calculate short-term vs long-term capital gains tax on investments with NIIT.',
    icon: 'query_stats',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/capital-gains',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Capital Gains Tax Calculator – Short-Term vs Long-Term Capital Gains',
    description: 'Free capital gains tax calculator. Calculate short-term and long-term capital gains tax on stocks, real estate, and investments. Includes NIIT surtax, filing status brackets, and side-by-side holding period comparison.',
  },
};

export default meta;
